
import styled from "styled-components";
import { FormContent } from "./Content";

export const ReleaseDetails = () => {
 
    return (
        <>
            <Container>
                <StepsContainer>
                    <StepContainer>
                        <FormContent />
                    </StepContainer>
                </StepsContainer>
            </Container>
        </>
    );
};

const Container = styled.div`
    background-color: ${props => props.theme.palette.background.base};
    display: flex;
    flex-direction: column;
    padding: 0px 0px 0px 0px;
`;

const StepsContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 18px;
    flex: 1;
`;

const StepContainer = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    border-radius: 30px;
    background-color: ${props => props.theme.palette.background.primary};
`;


const Loading = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
`;